import Vue from 'vue'
import Router from 'vue-router'
import Activities from '@/nvui/activities/Activities'
import Comment from '@/nvui/activities/Comment'
import NotFoundComponent from '@/nvui/error/404'

Vue.use(Router)

export default new Router({
    // https://router.vuejs.org/zh-cn/essentials/history-mode.html
    mode: 'history',
    routes: [
        // {path: '/', redirect: '/activities'},
        {
            path: '/',
            name: 'Activities',
            component: Activities,
            meta: {
                title_key: 'activities_title'
            }
        },
        {
            path: '/comment',
            name: 'Comment',
            component: Comment
        },
        {path: '*', component: NotFoundComponent}
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js